import FailedInteractionMessage from "@/components/audits/FailedInteractionMessage";
import InteractionReplay from "@/components/audits/InteractionReplay";
import StatusBadge from "@/components/audits/StatusBadge";
import UsabilityEvaluationSection from "@/components/audits/UsabilityEvaluationSection";
import type { Audit } from "@/types";
import { auditTimeLabel } from "@/utils/auditTimeLabel";
import { hostFromUrl } from "@/utils/formatters";

type PublicShowProps = {
  audit: Audit;
};

export default function PublicShow({ audit }: PublicShowProps) {
  const pageTitle = audit.scenario.objective || "Public audit";

  return (
    <main className="min-h-screen bg-gray-50">
      <title>{pageTitle}</title>
      <div className="border-b border-gray-200 bg-white">
        <div className="container mx-auto px-6 py-4">
          <p className="text-sm font-semibold uppercase tracking-wide text-primary">Public audit</p>
          <h1 className="mt-1 text-2xl font-semibold text-gray-900">{pageTitle}</h1>
        </div>
      </div>

      <div className="container mx-auto p-6">
        <section className="card mb-6">
          <div className="card-body">
            <div className="flex flex-col justify-between gap-4 md:flex-row md:items-start">
              <div>
                <div className="mb-3 flex flex-wrap items-center gap-3">
                  <StatusBadge status={audit.status} />
                  <p className="text-sm text-gray-500">{auditTimeLabel(audit)}</p>
                </div>
                <h2 className="text-lg font-semibold text-gray-800">Audit overview</h2>
                <p className="mt-2 text-gray-600">{audit.scenario.objective || "No instructions were provided."}</p>
              </div>
              {audit.scenario.start_url ? (
                <a
                  href={audit.scenario.start_url}
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-gray hover:text-primary"
                >
                  {hostFromUrl(audit.scenario.start_url)}
                </a>
              ) : null}
            </div>
          </div>
        </section>

        <FailedInteractionMessage audit={audit} />
        <UsabilityEvaluationSection evaluation={audit.usability_evaluation} interactions={audit.interactions} />
        <InteractionReplay audit={audit} />
      </div>
    </main>
  );
}
